module.exports = __webpack_public_path__ + "img/type-style6.fda78938.png";